module.exports = __webpack_public_path__ + "img/base_hebergements_lit.c91f7f9c.svg";